import { createContext } from 'react';


const CurrentcompositionContext = createContext([]);



export default CurrentcompositionContext